// IntroAlgorithmsPage.jsx
import React from 'react';
import { Grid, Paper, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

function IntroAlgorithmsPage() {
  const interactives = [
    {
      id: 'bfs',
      title: 'BFS Tree Exploration',
      description:
        'Visualize breadth-first search, layers, and BFS trees starting from a source node.',
      path: '/intro-algorithms/bfs',
    },
    {
      id: 'kruskal',
      title: "Kruskal's MST Algorithm",
      description:
        'Step through Kruskal’s algorithm and see how the minimum spanning tree is built.',
      path: '/intro-algorithms/kruskal',
    },
    {
      id: 'maxflow-mincut',
      title: 'Max-Flow / Min-Cut',
      description:
        'Explore augmenting paths, residual graphs, and the max-flow min-cut theorem.',
      path: '/intro-algorithms/maxflow-mincut',
    },
    {
      id: 'zero-indegree',
      title: 'Zero In-Degree Topological Sort',
      description:
        'Interactively apply the zero in-degree algorithm on random DAGs to build a topological order.',
      path: '/intro-algorithms/zero-indegree',
    },
  ];

  return (
    <section className="info-section" style={{ padding: '20px' }}>
      <Typography variant="h4" gutterBottom>
        Intro Algorithms Interactives
      </Typography>
      <Typography variant="body1" paragraph>
        Small visual tools for teaching core algorithms in an introductory course.
      </Typography>

      <Grid container spacing={2}>
        {interactives.map((interactive) => (
          <Grid item xs={12} md={6} key={interactive.id}>
            <Paper style={{ padding: '16px' }}>
              <Typography variant="h6" gutterBottom>
                {interactive.title}
              </Typography>
              <Typography variant="body2" paragraph>
                {interactive.description}
              </Typography>
              <Button
                variant="outlined"
                component={RouterLink}
                to={interactive.path}
              >
                Open interactive
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </section>
  );
}

export default IntroAlgorithmsPage;
